export const rendererTTRSeverityTracking = {
  enabled: true,
  severityDegradedThreshold: 1793,
  severityNormalThreshold: 1481,
};

// XXX When we removed the feature flag for this tracking value, the feature
// was targeting only 10% of users. We could try to roll that out at some
// point, but I'm unfamiliar with this tracking and didn't want to change
// anything at this point. The feature has been unchanged for more than a year.
let contentTracking;
if (Math.random() < 0.1) {
  contentTracking = {
    enabled: true,
    thresholds: {
      blocking: 1.5,
      degraded: 1,
    },
  };
}

export const unsupportedContentLevelsTracking = contentTracking;
